import { Slide } from "packages/lesson/dist/@types";

import { task as task01 } from "../../../../../task/course-05/lesson-17/task-01";

const task: Slide = {
  titleHtml:
    "If the single number value sound reduction index of concrete wall is  R’<sub>w</sub> = 62 dB</br>and surface of the wall is 16 m<sup>2</sup> and we add door with sound reduction index R’<sub>w</sub> = 25 dB</br>with surface 3,75 m<sup>2</sup> the overall sound reduction index R’<sub>w</sub> is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
